import { useId, useState } from "react";
import { PortableText } from "./PortableText";
import "./FaqListItem.css";

type FaqListItemBaseProps = {
  defaultExpanded?: boolean;
  title: string;
};

type FaqListItemProps = FaqListItemBaseProps &
  (
    | {
        description: string;
        descriptionFormat: "html";
      }
    | {
        description: unknown;
        descriptionFormat?: "portable-text";
      }
  );

export function FaqListItem({
  defaultExpanded = false,
  description,
  descriptionFormat = "portable-text",
  title,
}: FaqListItemProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const contentId = useId();

  return (
    <div
      className={`react-pdp__faq-item${
        isExpanded ? " react-pdp__faq-item--expanded" : ""
      }`}
    >
      <button
        aria-controls={contentId}
        aria-expanded={isExpanded}
        className="react-pdp__faq-trigger"
        onClick={() => setIsExpanded((current) => !current)}
        type="button"
      >
        <span className="react-pdp__faq-title">{title}</span>
        <span
          aria-hidden="true"
          className="material-symbols-rounded react-pdp__faq-icon"
        >
          {isExpanded ? "remove" : "add_2"}
        </span>
      </button>

      <div
        className="react-pdp__faq-content"
        id={contentId}
        inert={!isExpanded}
      >
        <div className="react-pdp__faq-content-inner">
          {descriptionFormat === "html" ? (
            <div
              className="react-pdp__faq-description react-pdp__faq-description--html"
              dangerouslySetInnerHTML={{ __html: description as string }}
            />
          ) : (
            <PortableText
              className="react-pdp__faq-description"
              value={description}
            />
          )}
        </div>
      </div>
    </div>
  );
}
